/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Checkbox, Select, Popconfirm,
} from 'antd';
import dayjs from 'dayjs';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';
import H3FormInput from '@Uilib/h3FormInput';
import Crown from '@Images/crown2.png';
import { INFINITE_EXPIRY_DATE, QUANTITY, DEFAULT_CUR_ROUND_OFF } from '@Apis/constants';
import HideValue from '../../../../../Common/RestrictedAccess/HideValue';
import ViewBatchCustomFields from '../../../../../Common/ViewBatchCustomFields';
import PRZSelect from '../../../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 * @param withApproval
 */
class BatchSelectorDN extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAllBatchesSelected: true,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.batches !== this.props?.batches) {
      const allSelected = this.props?.batches?.length > 0 &&
        this.props?.batches?.every(batch => batch?.batch_in_use);
      if (this.state?.isAllBatchesSelected !== allSelected) {
        this.setState({ isAllBatchesSelected: allSelected });
      }
    }
  }

  onToggleAllBatch = () => {
    const { batches, onToggleBatch, itemsRow } = this.props;
    const { isAllBatchesSelected } = this.state;
    const shouldSelectAll = !isAllBatchesSelected;

    this.setState({ isAllBatchesSelected: shouldSelectAll });

    batches?.forEach((batch) => {
      if (batch?.batch_in_use !== shouldSelectAll) {
        onToggleBatch(batch, itemsRow);
      }
    });
  };

  getColumns() {
    const { priceMasking } = this.props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    const { isAllBatchesSelected } = this.state;
    const batchColumns = [
      {
        title: (
          <Checkbox
            checked={isAllBatchesSelected}
            onChange={this.onToggleAllBatch}
          />
        ),
        fixed: 'left',
        render: (record) => {
          const { onToggleBatch, itemsRow, disableToggleBatch } = this.props;
          return (
            <Checkbox
              checked={record?.batch_in_use}
              onChange={() => onToggleBatch(record, itemsRow)}
              disabled={record?.is_reserved || disableToggleBatch}
            />
          );
        },
        hidden: false,
      },
      {
        title: 'Batch#',
        render: (text, record) => {
          const { org, itemsRow } = this.props;
          const batchConfig = org?.organisation?.[0]?.inventory_config?.settings?.batch_management;
          return (
            <div>
              <H3Text text={record?.custom_batch_number || record?.batch_number} style={{ fontWeight: '500' }} />
              <div className="table-subscript">
                {record?.lot_number && batchConfig?.lot_number_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Lot#</span>
                      {' '}
                      {record?.lot_number}
                    </span>
                  )}
                  />
                )}
                {record?.ar_number && batchConfig?.ar_number_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>AR#</span>
                      {' '}
                      {record?.ar_number}
                    </span>
                  )}
                  />
                )}
                {record?.batch_barcode && batchConfig?.batch_barcode_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Barcode</span>
                      {' '}
                      {record?.batch_barcode}
                    </span>
                  )}
                  />
                )}
                {record?.batch_inward_date && batchConfig?.batch_inward_date_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Inward Date</span>
                      {' '}
                      {dayjs(record?.batch_inward_date).format('DD MMM, YY')}
                    </span>
                  )}
                  />
                )}
                {record?.roll_no && batchConfig?.roll_no_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Roll No#</span>
                      {' '}
                      {record?.roll_no}
                    </span>
                  )}
                  />
                )}
                {record?.mrp > 0 && batchConfig?.mrp_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>MRP</span>
                      {' '}
                      {this.props.MONEY(record?.mrp)}
                    </span>
                  )}
                  />
                )}
                {record?.selling_price > 0 && batchConfig?.selling_price_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>SP</span>
                      {' '}
                      {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view selling price"} /> : this.props.MONEY(record?.selling_price)}
                    </span>
                  )}
                  />
                )}
                {record?.landed_cost > 0 && batchConfig?.landed_cost_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Landed Cost</span>
                      {' '}
                      {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view landed cost"} /> : this.props.MONEY(record?.landed_cost)}
                    </span>
                  )}
                  />
                )}
                {record?.freight_cost > 0 && batchConfig?.freight_cost_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Freight Cost</span>
                      {' '}
                      {this.props.MONEY(record?.freight_cost)}
                    </span>
                  )}
                  />
                )}
                {record?.other_cost > 0 && batchConfig?.other_cost_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Other Cost</span>
                      {' '}
                      {this.props.MONEY(record?.other_cost)}
                    </span>
                  )}
                  />
                )}
                {record?.margin > 0 && batchConfig?.margin_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Margin</span>
                      {' '}
                      {parseFloat(Number(record?.margin).toFixed(DEFAULT_CUR_ROUND_OFF))}%
                    </span>
                  )}
                  />
                )}
                {record?.brand && batchConfig?.brand_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Brand</span>
                      {' '}
                      {record?.brand}
                    </span>
                  )}
                  />
                )}
                {record?.mfg_batch_no && batchConfig?.mfg_batch_no_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Mfg batch #</span>
                      {' '}
                      {record?.mfg_batch_no}
                    </span>
                  )}
                  />
                )}
                {record?.manufacturing_date && batchConfig?.manufacturing_date_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Mfg Date</span>
                      {' '}
                      {Helpers.batchDateFormatter(record?.manufacturing_date, itemsRow?.manufacturingDateFormat)}
                    </span>
                  )}
                  />
                )}
                {record?.next_qc_date && batchConfig?.next_qc_date_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Next QC Date</span>
                      {' '}
                      {dayjs(record?.next_qc_date).format('DD MMM, YY')}
                    </span>
                  )}
                  />
                )}
                {record?.last_qc_date && batchConfig?.last_qc_date_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Last QC Date</span>
                      {' '}
                      {dayjs(record?.last_qc_date).format('DD MMM, YY')}
                    </span>
                  )}
                  />
                )}
              </div>
            </div>

          );
        },
        width: '120px',
      },
      {
        title: 'Expiry',
        width: '80px',
        render: (text, record) => (record?.expiry_date !== INFINITE_EXPIRY_DATE ? Helpers.batchDateFormatter(record?.expiry_date, this.props.itemsRow?.expiryDateFormat) : '-'),
      },
      {
        title: 'Shelf Life',
        width: '180px',
        render: (text, record) => {
          const { expiryDays } = this.props;
          const expiryMoment = dayjs(dayjs(record.expiry_date).format('YYYY-MM-DD'));
          let shelfLife = 0;
          if (dayjs().isSameOrBefore(expiryMoment)) {
            shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
          }
          let shelfLifePct = Math.round(((shelfLife / expiryDays) * 100));
          if (record?.expiry_date === INFINITE_EXPIRY_DATE) shelfLifePct = 100;
          if (expiryDays < 0) {
            return (
              <div style={{ width: '220px' }}>
                No Expiry (100%)
              </div>
            );
          }
          return (
            (
              <div className="batch-shelf-life">
                <div
                  className="progress-line__wrapper"
                  style={{
                    width: '80px',
                    backgroundColor: shelfLifePct < 25 ? 'rgba(216,51,15,0.2)' : shelfLifePct > 75 ? 'rgba(23,181,77,0.2)' : 'rgba(204,185,10,0.2)',
                  }}
                >
                  <div
                    className="progress-line"
                    style={{
                      width: `${shelfLifePct > 100 ? 100 : shelfLifePct}%`,
                      backgroundColor: shelfLifePct < 25 ? '#D8330F' : shelfLifePct > 75 ? '#17B54D' : '#CCB90A',
                    }}
                  />
                </div>
                <span>
                  {record?.expiry_date === INFINITE_EXPIRY_DATE ? 'NA' : `${shelfLife} Days (${shelfLifePct}%)`}
                </span>
              </div>
            )
          );
        },
      },
      {
        title: 'Cost Price',
        render: (text, record) => (record?.cost_price ? ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view cost price"} /> : this.props.MONEY(record?.cost_price)) : '-'),
      },
      {
        title: 'Available Qty',
        render: (text, record) => {
          const { uomInfo } = this.props;
          return (
            <div>{`${QUANTITY(record?.available_qty || 0, uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`}</div>
          );
        },
      },

      {
        title: 'Received Qty',
        render: (text, record) => {
          const { uomInfo } = this.props;
          return (
            <div>{`${QUANTITY(record?.consumed_qty || 0, uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`}</div>
          );
        },
      },
      {
        title: 'Quality',
        render: (text, record) => (
          <div className="qr__status" style={{ backgroundColor: record?.is_rejected_batch ? '#ee2232' : '#2fbc6e' }}>
            {record?.is_rejected_batch ? 'Bad' : 'Good'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Returned Qty',
        render: (text, record) => {
          const { uomInfo } = this.props;
          return (
            <div>{`${QUANTITY(record?.dn_gen_qty || 0, uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`}</div>
          );
        },
      },
      {
        title: 'Custom Fields',
        render: (record) => (<div style={{ minWidth: '140px' }}><ViewBatchCustomFields customFields={record?.custom_fields} /></div>),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: () => {
          const batchConsumedQtyEditable = this.props.user?.tenant_info?.inventory_config?.settings?.enable_batch_consumed_qty_editable;
          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div>To Be Returned</div>
              {!batchConsumedQtyEditable && (
                <Popconfirm
                  placement="topRight"
                  title="This feature is not accessible within your current plan to use this feature contact us."
                  onConfirm={() => window.Intercom('showNewMessage')}
                  okText="Contact Us"
                  cancelText="Cancel"
                >
                  <img
                    className="heading-restrict"
                    src={Crown}
                    alt="premium"
                    style={{
                      marginLeft: '6px',
                      marginTop: '-3px',
                    }}
                  />
                </Popconfirm>
              )}
            </div>
          );
        },
        render: (text, record) => {
          const {
            uomInfo, debitNoteWithReturnedQyt, updateBatchValue, user,
          } = this.props;
          const quantityToUse = debitNoteWithReturnedQyt ? record?.returned_quantity : record?.quantity;
          const batchConsumedQtyEditable = user?.tenant_info?.inventory_config?.settings?.enable_batch_consumed_qty_editable;

          return (
            // <div style={{ color: quantityToUse ? 'red' : 'black' }}>{`${quantityToUse ? '-' : ''}${QUANTITY(quantityToUse || '0', uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`}</div>
            <React.Fragment>
              {batchConsumedQtyEditable && (
                <H3FormInput
                  value={quantityToUse || ''}
                  type="text"
                  containerClassName={`${(Number(quantityToUse) < 0 || Number(quantityToUse) > Number(record?.consumed_qty)) ? 'form-error__input' : 0}`}
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  onChange={(event) => {
                    updateBatchValue(event.target.value, debitNoteWithReturnedQyt ? 'returned_quantity' : 'quantity', record?.batch_id);
                  }}
                  disabled={!batchConsumedQtyEditable || !record?.batch_in_use}
                />
              )}
              <div style={{ color: quantityToUse ? 'red' : 'black' }}>{`${quantityToUse ? '-' : ''}${QUANTITY(quantityToUse || '0', uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`}</div>
            </React.Fragment>
          );
        },
      },
    ];
    return batchColumns;
  }


  render() {
    const {
      batches, itemsRow, updateData, data, user, allStock, upDateAllStock, batchMethod, updateBatchConsumptionMethod,
    } = this.props;
    const batchColumns = this.getColumns()?.filter((column) => !column.hidden);

    const copyData = JSON.parse(JSON.stringify(data));
    const enabledWarehouseLocations = user?.tenant_info?.inventory_config?.settings?.enable_location_based_stock;

    return (
      <div className="batch-selector-wrapper">
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
        }}
        >
          <H3Text text="Received Batches" className="batch-selector-title" />

          <div style={{ display: 'flex', alignItems: 'center' }}>

            <div className="batch-selector-method">
              <PRZSelect
                filterOption={false}
                showSearch
                value={batchMethod}
                onChange={(value) => {
                  updateBatchConsumptionMethod(value);
                }}
              >
                <Option key="FEFO" value="FEFO">FEFO</Option>
                <Option key="FIFO" value="FIFO">FIFO</Option>
              </PRZSelect>
            </div>
            <div className="flex-align-space-between">
              <Checkbox
                checked={!!itemsRow.updateStock}
                onChange={() => {
                  const updatedData = copyData.map((obj) => {
                    if (obj.key === itemsRow.key) {
                      return { ...obj, updateStock: !itemsRow.updateStock };
                    }
                    return obj;
                  });
                  updateData(updatedData);
                }}
              >
                Return From Stock
              </Checkbox>
              {/* {String(allStock) && (<Switch checked={allStock} onChange={() => upDateAllStock(!allStock)} checkedChildren="Good Stock Only" unCheckedChildren="All Stock Batches" />
            )} */}
            </div>
          </div>

        </div>
        <Table
          size="small"
          columns={enabledWarehouseLocations ? [...batchColumns, {
            title: 'Location',
            render: (text, record) => (record?.inventory_location_path),
            responsive: ['sm', 'md', 'lg', 'xxl'],
          }] : batchColumns}
          dataSource={allStock ? batches?.filter((batch) => !batch?.is_rejected_batch) : batches}
          pagination={false}
          bordered
          scroll={{ x: 'max-content', }}
        />
      </div>
    );
  }
}

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  org: UserReducers.org,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({

});

BatchSelectorDN.propTypes = {
  productUomInfo: PropTypes.func,
  itemsRow: PropTypes.any,
  batches: PropTypes.any,
  uomInfo: PropTypes.any,
  noCalculations: PropTypes.bool,
  upDateAllStock: PropTypes.func,
  allStock: PropTypes.bool,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BatchSelectorDN));
